import React from 'react';
import { MIDAS_MODULES } from '../../models/EnumMidasModules';
import SearchCustomerComponent from '../../shared/SearchCustomerComponent/SearchCustomerComponent';
import { ICustomerProps } from './ICustomerProps';
import './Customer.scss';

export const Customer: React.FC<ICustomerProps> = () =>
  <SearchCustomerComponent parentComponent={MIDAS_MODULES.CUSTOMER} />;